export default "__VITE_ASSET__CTMpM9FK__"